import { useEffect, useState } from "react";
import { client, urlFor } from "../lib/sanity";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import "./AllaFastigheter.css";

const AllaFastigheter = () => {
    const { t } = useTranslation();
    const [fastigheter, setFastigheter] = useState([]);

    useEffect(() => {
        client
            .fetch(`*[_type == "property"] | order(sold asc, soonListing asc, _createdAt desc) {
                ...,
                "images": images[]{
                    asset->{
                        _id,
                        url
                    }
                }
            }`)
            .then(setFastigheter)
            .catch(console.error);
    }, []);

    const tillSalufastigheter = fastigheter.filter(f => !f.sold && !f.soonListing);
    const kommandeFastigheter = fastigheter.filter(f => !f.sold && f.soonListing);
    const saldaFastigheter = fastigheter.filter(f => f.sold);

    const displayFastigheter = [...tillSalufastigheter];
    if (tillSalufastigheter.length % 2 !== 0) {
        displayFastigheter.splice(2, 0, { contactCard: true, _id: "contact-card" });
    }

    const renderPropertyCard = (f, statusType) => {
        const isSold = statusType === 'sold';
        const CardTag = isSold ? 'div' : RouterLink;
        const cardProps = isSold
            ? { className: "mag-card is-sold" }
            : { to: `/fastighet/${f._id}`, className: "mag-card" };

        const imageUrl = f.images?.[0]?.asset
            ? urlFor(f.images[0]).width(1600).url()
            : null;

        return (
            <CardTag key={f._id} {...cardProps}>
                <div className={`mag-card-image-wrapper ${statusType ? `overlay-${statusType}` : ""}`}>
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={f.address || "Fastighet"}
                            loading="lazy"
                        />
                    ) : (
                        <div className="mag-card-placeholder"></div>
                    )}
                    <div className="mag-status-tags">
                        {isSold && <span className="tag sold-tag">{t("sold")}</span>}
                        {statusType === 'coming' && <span className="tag coming-tag">{t("comingSoon")}</span>}
                        {f.bidding && !f.sold && <span className="tag bidding">{t("bidding")}</span>}
                    </div>
                </div>

                <div className="mag-card-content">
                    <span className="mag-card-city-label">{f.city}</span>
                    <h3 className="mag-card-address">{f.address}</h3>
                    <div className="mag-card-details-group">

                        {/* RUM - Visas bara om det finns ett värde */}
                        {f.rooms && (
                            <span className="mag-detail">{f.rooms} {t("rooms")}</span>
                        )}

                        {/* KVADRATMETER - Döljs om tomt, lägger till separator om rum visades innan */}
                        {f.livingArea && (
                            <>
                                {f.rooms && <span className="mag-sep">/</span>}
                                <span className="mag-detail">{f.livingArea} m²</span>
                            </>
                        )}

                        {/* MÅNADSAVGIFT */}
                        {f.monthlyFee && (
                            <>
                                {(f.rooms || f.livingArea) && <span className="mag-sep">/</span>}
                                <span className="mag-detail">{f.monthlyFee.toLocaleString("sv-SE")} kr/mån</span>
                            </>
                        )}

                        {/* PRIS - Visas bara om värde finns. Hanterar både sålda (finalPrice) och aktuella */}
                        {(isSold ? (f.finalPrice || f.price) : f.price) && (
                            <>
                                {(f.rooms || f.livingArea || f.monthlyFee) && <span className="mag-sep">/</span>}
                                <span className="mag-card-price">
                                    {(isSold ? (f.finalPrice || f.price) : f.price).toLocaleString("sv-SE")} SEK
                                </span>
                            </>
                        )}
                    </div>
                </div>
            </CardTag>
        );
    };

    return (
        <section className="mag-list-section alla-fastigheter-page">
            <div className="mag-container">
                <span className="mag-label">{t("currentPropertiesLabel")}</span>

                <header className="mag-list-header">
                    <h1 className="mag-list-title">{t("currentProperties")}</h1>
                    <p className="mag-list-intro">{t("exploreProperties")}</p>
                </header>

                <div className="mag-main-grid">
                    {displayFastigheter.map(f =>
                        f.contactCard ? (
                            <div key={f._id} className="mag-card contact-editorial-card">
                                <div className="contact-card-inner">
                                    <span className="contact-label">Personlig service</span>
                                    <h2>Peter Olvsborn</h2>
                                    <p>Hittar du inte det du söker? Låt mig hjälpa dig.</p>
                                    <a href="mailto:peter@dinmaklareahus.se" className="mag-contact-btn">
                                        Kontakta mig
                                    </a>                               
                                </div>
                            </div>
                        ) : (
                            renderPropertyCard(f)
                        )
                    )}
                </div>

                {kommandeFastigheter.length > 0 && (
                    <div className="property-category-section">
                        <div className="category-divider">
                            <span>{t("comingSoon")}</span>
                            <hr />
                        </div>
                        <div className="mag-main-grid">
                            {kommandeFastigheter.map(f => renderPropertyCard(f, 'coming'))}
                        </div>
                    </div>
                )}

                {saldaFastigheter.length > 0 && (
                    <div className="property-category-section">
                        <div className="category-divider">
                            <span>{t("soldProperties")}</span>
                            <hr />
                        </div>
                        <div className="mag-main-grid">
                            {saldaFastigheter.slice(0, 4).map(f => renderPropertyCard(f, 'sold'))}
                        </div>
                        <div className="category-action-footer">
                            <RouterLink to="/soldObjects" className="mag-btn-editorial">
                                <span>{t("seeMoreSold")}</span>

                            </RouterLink>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default AllaFastigheter;